export interface ExpenseBulkSelectFilter {
    employees: { id: number; name: string }[];
    expenseDateFrom: string | null;
    expenseDateTo: string | null;
    billable: boolean;
    nonBillable: boolean;
}

export interface BulkSelectableExpense {
    id: number;
    employee?: { id: number; name: string } | null;
    expenseDate: string;
    isNonBillable: boolean;
    isSelectable: boolean;
}

export function filterBulkSelectableExpenses<T extends BulkSelectableExpense>(
    expenses: T[],
    { employees, expenseDateFrom, expenseDateTo, billable, nonBillable }: ExpenseBulkSelectFilter
): T[] {
    return expenses
        .filter((exp) => exp.isSelectable)
        .filter((exp) => {
            const byEmployee = employees.length == 0 || employees.some((employee) => employee.id === exp.employee?.id);

            let byDateRange = true;
            if (expenseDateFrom || expenseDateTo) {
                if (expenseDateFrom && exp.expenseDate < expenseDateFrom) {
                    byDateRange = false;
                }
                if (expenseDateTo && exp.expenseDate > expenseDateTo) {
                    byDateRange = false;
                }
            }

            // Both or neither billability box ticked means no billability restriction.
            const byBillability = billable === nonBillable || (billable ? !exp.isNonBillable : exp.isNonBillable);

            return byEmployee && byDateRange && byBillability;
        });
}
